/* eslint-disable prefer-destructuring */

import isNewCar from "@utils/isNewCar";
import { captureExceptions } from "@utils/sentry";

const ratingReview = {
  zd: {
    rating: 4.9,
    reviewBaseCount: 312630
  },
  comp: {
    rating: 4.7,
    reviewBaseCount: 360340
  },
  tp: {
    rating: 4.2,
    reviewBaseCount: 294860
  },
  od: {
    rating: 4.7,
    reviewBaseCount: 200145
  },
  odZd: {
    rating: 4.9,
    reviewBaseCount: 156831
  }
};

export const getNewReviewCount = baseCount => {
  const goLiveDate = new Date(1671042600000).getTime(); // 15 Dec 2022 // Go live date
  const onDayTime = 24 * 60 * 60 * 1000;
  const currentDate = new Date().getTime();
  const dateDiff = Math.ceil((currentDate - goLiveDate) / onDayTime);

  // const reviewCountIncrement = dateDiff * 20 + (dateDiff % 10); // for incrementing between 0 to 10

  // for incrementing between 20 to 30
  const factor = dateDiff => {
    const f = 1 + (dateDiff % 10) / 10;
    if (f === 1) {
      return 1.5;
    } else if (f < 1.5) {
      return 2 + (dateDiff % 10) / 10;
    } else {
      return f;
    }
  };
  const reviewCountIncrement =
    dateDiff * 20 +
    (10 - (dateDiff % 10)) +
    Math.ceil(dateDiff * factor(dateDiff));

  return baseCount + reviewCountIncrement;
};

export const zeroDepMap = {
  car_comprehensive: ["zero_dep", "zero_dep_deductible"],
  car_acko_garage_comprehensive_deductible: [
    "car_acko_garage_zero_dep_deductible"
  ],
  car_bundled: ["car_bundled_with_zd"],
  car_od: ["zero_dep_od", "zero_dep_deductible_od"]
};

export const generateDescription = (model, description) => {
  const descriptionObj: any = {
    bold: "",
    content: "",
    secondContent: ""
  };

  if (
    description &&
    (description.includes("{model}") ||
      description.includes("{bold}") ||
      description.includes("{break}"))
  ) {
    // Insertion
    const descriptionInsetModel =
      description && description.includes("{model}")
        ? description.replace("{model}", model)
        : description;

    // Content break
    let descriptionFilterBreak = "";
    if (descriptionInsetModel && descriptionInsetModel.includes("{break}")) {
      descriptionFilterBreak = descriptionInsetModel.split("{break}")[0];
      descriptionObj.secondContent = descriptionInsetModel.split("{break}")[1];
    } else {
      descriptionFilterBreak = descriptionInsetModel;
    }

    // Content Bold
    let descriptionBold = "";
    if (descriptionFilterBreak && descriptionFilterBreak.includes("{bold}")) {
      descriptionBold = descriptionFilterBreak.substring(
        "{bold}".length,
        descriptionFilterBreak.indexOf("{/bold}")
      );
      descriptionFilterBreak = descriptionFilterBreak.replace("{bold}", "");
      descriptionFilterBreak = descriptionFilterBreak.replace("{/bold}", "");
      descriptionFilterBreak = descriptionFilterBreak.replace(
        descriptionBold,
        ""
      );
    } else {
      descriptionBold = "";
    }

    // Assigning to description Object
    descriptionObj.content = descriptionFilterBreak;
    descriptionObj.bold = descriptionBold;

    return descriptionObj;
  }
  descriptionObj.content = description;
  return descriptionObj;
};

export const gridViewPlansGroup = plansData => {
  const cps = plansData.filter(
    item => item.parent_plan_name === "Comprehensive Plans"
  );
  const zps = plansData.filter(
    item => item.parent_plan_name === "Zero Dep Plans"
  );
  const tps = plansData.filter(
    item => item.parent_plan_name === "Third Party Only Plan"
  );
  const obj = {
    cp_plan: {
      heading: cps && cps[0]?.parent_plan_name,
      description:
        cps && cps[0]?.parent_plan_description
          ? cps[0]?.parent_plan_description
          : "",
      plans: cps
    },
    zd_plan: {
      heading: zps && zps[0]?.parent_plan_name,
      description:
        zps && zps[0]?.parent_plan_description
          ? zps[0]?.parent_plan_description
          : "",
      plans: zps && zps
    },
    tp_plan: {
      heading: tps && tps[0]?.parent_plan_name,
      description:
        tps && tps[0]?.parent_plan_description
          ? tps[0]?.parent_plan_description
          : "",
      plans: tps
    }
  };
  return obj;
};

function sortUtil(p1, p2) {
  return p1.price.net_premium < p2.price.net_premium ? -1 : 1;
}

export const getLowestFirstLookPlans = pData => {
  // This util updates the price of the standard plan with the lowest price among variants
  const cpStandard = pData?.filter(item => item.id === standardPlans.comp);
  const czdStandard = pData?.filter(item => item.id === standardPlans.zd);
  const odStandard = pData?.filter(item => item.id === standardPlans.od);
  const ozdStandard = pData?.filter(item => item.id === standardPlans.zd_od);
  const cps = pData
    ?.filter(item => item.parent_plan_name_v2?.toLowerCase() === "comprehensive")
    .sort(sortUtil)[0];
  const zps = pData
    ?.filter(
      item =>
        item.parent_plan_name_v2?.toLowerCase() === "comprehensive + zero dep"
    )
    .sort(sortUtil)[0];
  const tps = pData
    ?.filter(item => item.parent_plan_name_v2?.toLowerCase() === "third party")
    .sort(sortUtil)[0];
  const ods = pData
    ?.filter(item => item.parent_plan_name_v2?.toLowerCase() === "own damage")
    .sort(sortUtil)[0];
  const ozds = pData
    ?.filter(
      item =>
        item.parent_plan_name_v2?.toLowerCase() === "own damage + zero dep"
    )
    .sort(sortUtil)[0];
  let renderData = Array();
  cps &&
    renderData.push({
      ...(cpStandard[0] || cps),
      original_price: cps?.original_price,
      discounted_price: cps?.discounted_price,
      id: cps?.id,
      reviewCount: getNewReviewCount(ratingReview?.comp?.reviewBaseCount),
      rating: ratingReview?.comp?.rating
    });
  zps &&
    renderData.push({
      ...(czdStandard[0] || zps),
      original_price: zps?.original_price,
      discounted_price: zps?.discounted_price,
      id: zps?.id,
      reviewCount: getNewReviewCount(ratingReview?.zd?.reviewBaseCount),
      rating: ratingReview?.zd?.rating
    });
  ods &&
    renderData.push({
      ...(odStandard[0] || ods),
      original_price: ods?.original_price,
      discounted_price: ods?.discounted_price,
      id: ods?.id,
      reviewCount: getNewReviewCount(ratingReview?.od?.reviewBaseCount),
      rating: ratingReview?.od?.rating
    });
  ozds &&
    renderData.push({
      ...(ozdStandard[0] || ozds),
      original_price: ozds?.original_price,
      discounted_price: ozds?.discounted_price,
      id: ozds?.id,
      reviewCount: getNewReviewCount(ratingReview?.odZd?.reviewBaseCount),
      rating: ratingReview?.odZd?.rating
    });
  tps &&
    renderData.push({
      ...tps,
      reviewCount: getNewReviewCount(ratingReview?.tp?.reviewBaseCount),
      rating: ratingReview?.tp?.rating
    });

  // let zd_smart_super = false;

  // const zdPlanCount = renderData.reduce((count, plan) => {
  //   if (plan.id.includes("zero_dep")) {
  //     count += 1;
  //     if (plan.id.includes("zero_dep_deductible")) {
  //       zd_smart_super = true;
  //     }
  //   }
  //   return count;
  // }, 0);

  // if (zd_smart_super && zdPlanCount === 1) {
  //   renderData = renderData.map(plan => {
  //     if (plan.id.includes("zero_dep_deductible")) {
  //       return { ...plan, priority: 100 };
  //     }
  //     return { ...plan };
  //   });
  // }

  renderData.sort((a, b) => {
    return a.priority - b.priority;
  });

  return renderData;
};

export const getLowestFirstLookPrice = (plan, plans) => {
  // showing deductible price for a standard plan
  if (!plan?.id.includes("deductible")) {
    if (plan?.id.includes("comprehensive")) {
      const plan = plans.filter(p =>
        p.id.includes("comprehensive_deductible")
      )[0];
      if (plan) {
        return plan?.discounted_price;
      }
    }
    if (plan?.id.includes("zero_dep")) {
      const plan = plans.filter(p => p.id.includes("zero_dep_deductible"))[0];
      if (plan) {
        return plan?.discounted_price;
      }
    }
  }
  return plan?.discounted_price;
};

const plansPriorityOrder = {
  car_acko_garage_comprehensive_deductible: 1,
  car_comprehensive_deductible: 2,
  car_comprehensive: 3,
  car_acko_garage_zero_dep_deductible: 3,
  zero_dep_deductible: 4,
  zero_dep: 5,
  zero_dep_deductible_od: 6,
  zero_dep_od: 7,
  car_od: 8
};

// Switching the plans priority for ZD plans in case of super and smart saver ZD plan
export const getPlansOrder = planData => {
  // let zd_smart_super = false;
  // const zdPlanCount = planData.reduce((count, plan) => {
  //   if (plan.id.includes("zero_dep")) {
  //     count += 1;
  //     if (plan.id.includes("zero_dep_deductible")) {
  //       zd_smart_super = true;
  //     }
  //   }
  //   return count;
  // }, 0);
  // if (zd_smart_super && zdPlanCount === 1) {
  //   planData = planData.map(plan => {
  //     if (plan.id.includes("zero_dep_deductible")) {
  //       return { ...plan, priority: 100 };
  //     }
  //     return { ...plan };
  //   });
  // }

  const planOrder = planData?.map(plan => {
    plan.priority = plansPriorityOrder[plan.id];
    return plan;
  });

  planOrder?.sort((a, b) => {
    return a.priority - b.priority;
  });

  return planOrder;
};



// By default prefer (Comprehensive Supersaver > Comprehenisve) over any other plan on initial plan page load
export const getDefaultPlan = planData => {
  for (const plan of planData) {
    if (plan.id === "car_acko_garage_comprehensive_deductible") {
      return plan;
    } else if (plan.id === "car_comprehensive") {
      return plan;
    }
  }
  return planData[0];
};

export const standardPlans = {
  comp: "car_comprehensive",
  zd: "zero_dep",
  zd_od: "zero_dep_od",
  od: "car_od"
};

export const generateDesc = (description, model) => {
  const descriptionInsetModel =
    description && description.includes("{model}")
      ? description.replace("{model}", model)
      : description;
  let finalDesc = descriptionInsetModel.replace(/{bold}/g, "<b>");
  return finalDesc.replace(/{\/bold}/g, "</b>");
};

export const getAddonDescription = description => {
  let finalDesc = description
    .replace(/{bold}/g, "<b>")
    .replace(
      /{ulist}/g,
      `<ul style="list-style-type: disc; list-style-position: outside; margin-left: 1rem">`
    )
    .replace(/{litem}/g, `<li><span style="position: relative; left: 6px;" >`)
    .replace(/\n/g, "<br/>")
    .replace(/{\/bold}/g, "</b>")
    .replace(/{\/litem}/g, `</span></li>`)
    .replace(/{\/ulist}/g, "</ul>");
  return finalDesc;
};

export const getAddonDescriptionWithTeslaCheck = (description, make) => {
  let finalDesc = "";
  if (make?.toLocaleLowerCase() === "tesla") {
    description = description.replace(
      "{/litem}{litem}Key repair/replacement {bold} up to ₹7,000.",
      ""
    );
    description = description.replace(
      "{/litem}{litem}Key repair/replacement {bold} up to ₹25,000",
      ""
    );
  }

  finalDesc = description
    .replace(/{bold}/g, "<b>")
    .replace(
      /{ulist}/g,
      `<ul style="list-style-type: disc; list-style-position: outside; margin-left: 1rem">`
    )
    .replace(/{litem}/g, `<li><span style="position: relative; left: 6px;" >`)
    .replace(/\n/g, "<br/>")
    .replace(/{\/bold}/g, "</b>")
    .replace(/{\/litem}/g, `</span></li>`)
    .replace(/{\/ulist}/g, "</ul>");

  return finalDesc;
};

// function to get the corresponding standard plan for a zero dep plan
export function getCorrespondingPlan(plan, plans) {
  const pPlanId = Object.entries(zeroDepMap).filter(entry => {
    return entry[1].includes(plan.id);
  })[0]?.[0];
  return plans.find(p => {
    return p.id == pPlanId;
  });
}

const getZeroDepDescription = (zdPlans, plan, pPlan) => {
  // pPlan is used to determine the addon price in case zero dep plan is selected one
  const isSmartSaver = zdPlans.find(
    p => p.id.includes("deductible") && !p.id.includes("acko_garage")
  );
  const addons = zdPlans.map(zd => {
    return {
      id: zd.id,
      is_selected: zd.id == plan.id,
      display_name:
        !zd.id.includes("acko_garage") && zd.id.includes("deductible")
          ? "Zero dep Smart Saver"
          : isSmartSaver
          ? "Zero dep"
          : "Zero dep (Bumper to Bumper)",
      tag:
        zdPlans.length > 1 && zd.id.includes("deductible")
          ? `Extra ₹ ${Math.round(
              Math.abs(
                zdPlans[0]?.price.net_premium - zdPlans[1]?.price.net_premium
              )
            )} smart saver discount`
          : "",
      description: zd?.description,
      price: {
        net_premium:
          zd?.["price"]?.net_premium -
          (pPlan ? pPlan?.price?.net_premium : plan?.price?.net_premium)
      }
    };
  });
  return addons;
};
export const getCorrespondingZDAddon = (plan, list) => {
  // check if zd plan is selected if so return selected as true
  if (plan?.id.includes("zero_dep") && getCorrespondingPlan(plan, list)) {
    const pPlan = getCorrespondingPlan(plan, list);
    const addonId = zeroDepMap[pPlan.id];
    const selectedAddons = list.filter(p => {
      return addonId.includes(p.id);
    });
    return getZeroDepDescription(selectedAddons, plan, pPlan);
  }
  const zeroDep = list.filter(l => {
    return zeroDepMap[plan?.id]?.includes(l?.id);
  });
  return zeroDep ? getZeroDepDescription(zeroDep, plan, null) : {};
};

// TODO To get the plans segment data directly from proposal reducer
export const getPlansSegmentData = (
  plansData: any,
  idvData?: any,
  defaultPlan?: any
) => {
  //todo add the coupon data
  const planSegmentData = {};
  try {
    plansData?.forEach((plan, idx) => {
      planSegmentData[`eligible_plan_name${idx + 1}`] = plan?.id;
      planSegmentData[`premium_plan_name${idx + 1}`] =
        plan?.price?.gross_premium;
      if (plan?.is_selected) {
        planSegmentData[`inspection_required`] = plan?.pi_required;
        planSegmentData[`addons`] = plan?.addons.map(addon => {
          return addon?.id;
        });
        planSegmentData[`addon_eligible_count`] = plan?.addons.length;
        planSegmentData[`plan_selected`] = plan?.id;
      }
    });

    if (idvData) {
      planSegmentData[`selected_idv`] =
        idvData?.selected && (idvData?.selected).toString();
      planSegmentData[`recommended_idv`] = idvData?.recommended;
    }
    if (defaultPlan) {
      planSegmentData[`inspection_required`] = defaultPlan?.pi_required;
      planSegmentData[`addons`] = defaultPlan?.addons.map(addon => {
        return addon?.id;
      });
      planSegmentData[`addon_eligible_count`] = defaultPlan?.addons.length;
      planSegmentData[`plan_selected`] = defaultPlan?.id;
    }
    if (isNewCar()) {
      delete planSegmentData[`inspection_required`];
    }
    return {
      ...planSegmentData,
      eligible_plans: plansData?.map(p => {
        return p?.id;
      })
    };
  } catch (error) {
    // returning null in case of any error in segment data
    captureExceptions(error, null);
    window?.newrelic.noticeError(error, {
      name: "getPlansSegmentData error in helper Utils"
    });
    return planSegmentData;
  }
};

// This function returns the selected electrical and nonElectrical accessories addons selected by the user
// added for segment events
export const getSelectedAccessoriesAddons = planDetails => {
  const selectedAccessoriesAddons = {
    electrical_accessories_value_entered: null,
    electrical_accessories_type_selected: null,
    non_electrical_accessories_value_entered: null,
    non_electrical_accessories_type_selected: null
  };
  try {
    planDetails?.selectedAdditionalCovers?.forEach(addon => {
      const electricalAccessory = [];
      const nonElectricalAccessory = [];
      if (addon?.is_accessory) {
        // string comparison should use CONST ?
        if (addon.id === "electrical_accessories_own_damage_basic_car") {
          addon?.assured_accessories?.forEach(accessry => {
            if (accessry?.is_selected) {
              //@ts-ignore
              electricalAccessory.push(accessry?.name);
            }
          });
          selectedAccessoriesAddons.electrical_accessories_value_entered =
            addon?.price?.net_premium;
          //@ts-ignore
          selectedAccessoriesAddons.electrical_accessories_type_selected = electricalAccessory;
        } else if (
          addon.id === "non_electrical_accessories_own_damage_basic_car"
        ) {
          addon?.assured_accessories?.forEach(accessry => {
            if (accessry?.is_selected) {
              //@ts-ignore
              nonElectricalAccessory.push(accessry?.name);
            }
          });
          selectedAccessoriesAddons.non_electrical_accessories_value_entered =
            addon?.price?.net_premium;
          //@ts-ignore
          selectedAccessoriesAddons.non_electrical_accessories_type_selected = nonElectricalAccessory;
        }
      }
    });
    return selectedAccessoriesAddons;
  } catch (error) {
    // returning null in case of any error in segment data
    captureExceptions(error, null);
    window?.newrelic.noticeError(error, {
      name: "getSelectedAccessoriesAddons error in helper utils"
    });
    return selectedAccessoriesAddons;
  }
};

export default {};
